import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;

	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: (rowData: any) => {
					const { deployedOnWebsite } = rowData;
					if (deployedOnWebsite) {
						return false;
					}
					return hasPermission({
						entity: DASHBOARD_RESOURCES.userSegment,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].updatePlatformFeature,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'View',
				id: 'view',
				isEnabled: (rowData: any) => {
					const { deployedOnWebsite } = rowData;
					if (deployedOnWebsite) {
						return false;
					}
					return hasPermission({
						entity: DASHBOARD_RESOURCES.userSegment,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].updatePlatformFeature,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.userSegment,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].updatePlatformFeature,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};
